export default __webpack_public_path__ + "static/media/earnIcon.daf2dbde.svg";